import { ProfileType, PropertyCountRangeType } from '@zg-rentals/ts-rental-manager-api-client';

export const PROFILE_TYPE_OPTIONS: Array<{ value: ProfileType; label: string }> = [
  { value: ProfileType.PROPERTY_MANAGER, label: 'Property manager' },
  { value: ProfileType.LANDLORD, label: 'Property owner or landlord' },
  { value: ProfileType.AGENT, label: 'Agent or broker' },
  { value: ProfileType.REAL_ESTATE_INVESTOR, label: 'Real estate investor' },
];

export const PROFILE_TYPE_LABELS: Record<ProfileType, string> = Object.fromEntries(
  PROFILE_TYPE_OPTIONS.map(({ value, label }) => [value, label]),
) as Record<ProfileType, string>;

export const PROPERTY_COUNT_OPTIONS: Array<{ value: PropertyCountRangeType; label: string }> = [
  { value: PropertyCountRangeType.ONE, label: '1 unit' },
  { value: PropertyCountRangeType.TWO_TO_TEN, label: '2–10 units' },
  { value: PropertyCountRangeType.ELEVEN_TO_FIFTY, label: '11–50 units' },
  { value: PropertyCountRangeType.FIFTY_ONE_TO_TWO_HUNDRED, label: '51–200 units' },
  { value: PropertyCountRangeType.TWO_HUNDRED_PLUS, label: '200+ units' },
];

export const PROPERTY_COUNT_LABELS: Record<PropertyCountRangeType, string> = Object.fromEntries(
  PROPERTY_COUNT_OPTIONS.map(({ value, label }) => [value, label]),
) as Record<PropertyCountRangeType, string>;
